module.exports = __webpack_public_path__ + "img/roll-959.fd751b18.png";